<template>
    <div>
        <kgr-loading v-show="loading" />
        <kgr-empty-data
            v-if="!loading && exams && exams.length === 0"
            :value="$t('dataTable.noData')"
        />
        <div v-show="!loading && exams && exams.length > 0">
            <kgr-exams-table
                v-if="view === 'list'"
                :exams="exams"
                :exam-edit-url="examEditUrl"
                can-edit
            />
        </div>
    </div>
</template>

<script>
import EmptyData from '../../common/EmptyData.vue';
import ExamsTable from '../../exams/ExamsTable.vue';
import Loading from '../../common/Loading.vue';

export default {
    components: {
        'kgr-exams-table': ExamsTable,
        'kgr-loading': Loading,
        'kgr-empty-data': EmptyData,
    },
    props: {
        exams: {
            type: Array,
            required: true,
        },
        memberId: {
            type: Number,
            required: true
        },
        view: {
            type: String,
            required: true,
        },
        loading: {
            type: Boolean,
            required: true,
            default: false
        }
    },
    methods: {
        examEditUrl(exam) {
            return `/backend/clubs/members/${this.memberId}/exams/${exam.id}/edit`;
        },
    },
}
</script>
